<template>
    <div class="card">
        <div v-if="title" class="card-header font-weight-bold" :class="headerClass">{{title}}</div>
        <div class="card-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "BaseCard",
    props: {
        title: {
            type: String,
        },
        type: {
            validator: value => ['success', 'warning', 'danger', 'primary', 'secondary', 'info'].indexOf(value) !== -1
        }
    },
    computed: {
        headerClass(){
            return this.type ? `bg-gradient-${this.type}` : '';
        }
    }
}
</script>

<style scoped>
    .card:hover {
        box-shadow: 0px 0px 10px lightgray;
        transition: all 0.3s ease;
    }
</style>